var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkText)?_c('div',{staticClass:"vm-ticker-container",attrs:{"hidden":_vm.preview}},[_c('div',{staticClass:"ticker-wrap"},[_c('div',{staticClass:"ticker"},_vm._l((_vm.texts),function(text){return _c('div',{key:text.index,staticClass:"ticker__item",domProps:{"innerHTML":_vm._s(text)}},[_vm._v(" "+_vm._s(text)+" ")])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }